/* The frame choices use the original transparent PNG artwork in Shopify assets. */
(() => {
  const choices = [
    { key: 'none', name: 'Ingen ramme' },
    { key: 'classic', name: 'Klassisk jul', file: 'Juleramme_klassisk.png' },
    { key: 'vintage', name: 'Vintage julekort', file: 'Juleramme_vintage.png' },
    { key: 'art-deco', name: 'Art deco-jul', file: 'Juleramme_art-deco.png' },
    { key: 'green', name: 'Kristtorn', file: 'Juleramme_grønn-jul.png' }
  ];
  const byKey = Object.freeze(Object.fromEntries(choices.filter(choice => choice.file).map(choice => [choice.key, choice])));

  function formatForRatio(ratio) {
    return Number(ratio) >= 0.85 ? 'square' : 'portrait';
  }

  function imageSource(key, root, format = 'square') {
    const thumb = root?.querySelector?.(`[data-frame-thumb="${key}"]`);
    if (thumb) {
      const source = format === 'portrait' ? thumb.dataset.frameImagePortrait : thumb.dataset.frameImageSquare;
      return source || '';
    }
    return byKey[key] ? `../assets/${byKey[key].file}` : '';
  }

  globalThis.OikosLabelFrames = Object.freeze({
    choices: Object.freeze(choices.map(choice => Object.freeze(choice))),
    imageSource,
    formatForRatio
  });
})();

